import { state } from '../models'

export function getType(): string {
    return state.type
}
